import template from "./pClients.html";
import angular from "angular";
import { getClientWarnings } from '../utils';

export function pClientsDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pClientsController,
    controllerAs: 'pClients',
    bindToController: true
  };

  return directive;
}

class pClientsController {
  constructor(Auth, Admin ,$q, $scope, $interval, Notes, DownloadFile) {
    'ngInject';

    this.Auth = Auth;
    this.Admin = Admin;
    this.$q = $q;
    this.$scope = $scope;
    this.$interval = $interval;
    this.Notes = Notes;
    this.DownloadFile = DownloadFile;

    this.dataOrder = ['country', 'mdpInfo', 'mdpId', 'name', 'additionalInfo', 'taxId', 'clientGroupId'];

    this.init();

    this.fields = {
      name: "info",
      additionalInfo: "info",
      taxId: "info",
      mdpName: "info",
      mdpId: "info",
      country: "info",
      clientGroupName: "info",
      // defaultBillingType: "info"
    };

    this.actions = [
      {
        name: "new",
        functionName: "startAddingNewClient",
        fa: "fa-plus"
      }
    ];

    this.rowActions = [
      {
        name: "edit",
        functionName: "startEditingClient",
        fa: "fa-pencil-alt"
      },
      {
        name: 'download_client_notes',
        functionName: 'downloadClientNotes',
        fa: 'fa-download'
      }
      // {
      //   name: "delete",
      //   functionName: "startDeletingClient",
      //   fa: "fa-trash"
      // }
    ];

    /*
    * b-dialog-card data
    */

    this.basicClientData = {
      country: {
        type: "select"
      },
      name: {
        type: "text"
      },
      additionalInfo: {
        type: "text",
        tooltip: true,
        isNotRequired: true
      },
      taxId: {
        type: "text"
      },
      clientGroupId: {
        type: "select"
      },
      multiselectKeywords: {
        type: "toDoList",
        isNotRequired: true
      }
      // defaultBillingType: {
      //   type: "select"
      // }
    };

    this.basicEditClientData = {
      country: {
        type: "select",
        editionDisabled: true
      },
      name: {
        type: "text"
      },
      additionalInfo: {
        type: "text",
        tooltip: true,
        isNotRequired: true
      },
      taxId: {
        type: "text"
      },
      clientGroupId: {
        type: "select"
      },
      multiselectKeywords: {
        type: "toDoList",
        isNotRequired: true
      }
      // defaultBillingType: {
      //   type: "select"
      // }
    };

    this.countrySelect = {
      country: {
        valueToAdd: "name",
        valueToShow: "name"
      },
      clientGroupId: {
        valueToAdd: "id",
        valueToShow: "name"
      }
    };

    this.editCountrySelect = {
      clientGroupId: {
        valueToAdd: "id",
        valueToShow: "name"
      }
    };

    this.warnings = {};
    this.similarName = null;
  }

  init() {
    this.state = 'loading';
    this.Auth.authorizeAdmin().then(
      (user) => {
        this.user = user;

        let promises = [this.Admin.getClients(), this.Admin.getCountries(), this.Admin.getClientGroups()];
        this.$q.all(promises).then(
          (success) => {
            this.clients = success[0].data.sort((a, b) => {
              if (a.name < b.name) {
                return -1;
              }
              if (a.name > b.name) {
                return 1;
              }

              return 0;
            }).map(client => ({
              ...client,
              mdpInfo: client.mdpId ? `${client.mdpName} (${client.mdpId})` : null
            }));

            this.countries = success[1].data;
            this.countrySelect.country.values = this.countries;

            let clientGroupId = success[2].data.sort((a,b)=>{
              if(a.name < b.name) return -1;
              if(a.name > b.name) return 1;
              return 0;
            });
            clientGroupId.unshift({id:"0",name:" "});
            this.countrySelect.clientGroupId.values = clientGroupId;
            this.editCountrySelect.clientGroupId.values = clientGroupId;
            this.state = 'loaded';
          },
          (error) => {
            this.state = 'loaded';
            this.Notes.postNote({type: "error", error: error});
          }
        );

        var timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 10);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout);});
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  startAddingNewClient() {
    this.newClientData = angular.copy(this.basicClientData);
    delete this.newClientData.mdpId;

    if (!this.user.isAdmin && !this.user.isLocalAdmin) {
      delete this.newClientData.additionalInfo;
    }

    this.newClientValues = {
      taxId: "MISSING",
      clientGroupId: "0",
      multiselectKeywords: []
    };
    this.newClientProcess = true;
    this.newClientMdpIdChanged = false;
    this.warnings = {};
    this.similarName = null;
  }

  addNewClient(client) {
    const clientsFromSelectedCountry = this.clients.filter(c => c.country === client.country);

    this.warnings = getClientWarnings(clientsFromSelectedCountry, client);

    if (this.warnings.blocked)
      return;

    if (
      !this.warnings.sameTax
      && !this.warnings.sameName
      && (this.warnings.similarNames && this.warnings.similarNames.length > 0)
      && this.similarName !== client.name  
    ) {
      this.similarName = client.name;
      return;
    }

    if (this.state == 'loading')
      return;

    this.state = 'loading';

    if(client.clientGroupId == "0") {
      delete client.clientGroupId;
    }

    delete client.multiselectKeywordsValue;

    this.Admin.addClient(client).then(
      () => {
        this.newClientProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    ).finally(() => this.warnings = {});
  }

  startEditingClient(client) {
    const countrySettings = this.countries.find(country => country.name === client.country);
    const mdpAvailable = countrySettings.flags.find(flag => flag === 'ClientMdpIdAvailable');
    const mdpRequired = countrySettings.flags.find(flag => flag === 'ClientMdpIdRequired');

    this.editClientData = angular.copy(this.basicEditClientData);

    if (!this.user.isAdmin && !this.user.isLocalAdmin) {
      delete this.editClientData.additionalInfo;
    }
    this.editClientProcess = true;
    this.editClientValues = angular.fromJson(angular.toJson(client));
    this.editCountrySelect.country = client.country;

    if (client.mdpInfo || mdpAvailable) {
      this.newNameFromMdp = null;
      this.editClientData.mdpInfo = {
        type: "textWithSearch",
        searchFn: (value) => this.searchMdpId(value),
        setClientFromMdp: (client) => this.setClientFromMdp(client),
        options: [],
        disabled: !mdpAvailable
      };

      this.editClientData.mdpId = {
        type: "text",
        editionDisabled: true
      };

      this.editClientData.name = {
        ...this.editClientData.name,
        buttonHandlerDisabled: true,
        buttonHandlerLabel: 'Override',
        buttonHandler: () => this.overrideClientName()
      };

      if (mdpRequired)
        this.editClientData.mdpInfo.isNotRequired = false;

      this.editClientData = this.dataOrder.reduce((accu, curr) => {
        accu[curr] = this.editClientData[curr];
        return accu;
      }, {});
    }

    if(!client.clientGroupId) {
      this.editClientValues.clientGroupId = "0";
    }

    if (!this.editClientValues.multiselectKeywords)
      this.editClientValues.multiselectKeywords = [];
  }

  updateClient(client) {
    delete client.multiselectKeywordsValue;

    if (this.state == 'loading')
      return;

    this.state = 'loading';

    if(client.clientGroupId == "0") {
      delete client.clientGroupId;
    }

    this.Admin.updateClient(client.id, client).then(
      () => {
        this.editClientProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  getMdpClients(name) {
    return this.Admin.getMdpClients(name)
      .then(
        (success) => {
          if (success.status === 204)
            return [];

          const clients = success.data.map(client => {
            return Object.entries(client).reduce((accu, [key, value]) => {
              accu[key] = value === 'brak' ? '' : value;
              return accu;
            }, {});
          });

          return clients.map(client => ({value: client.id, label: `${client.name} - ${client.country} ${client.streetAddress}, ${client.city} ${client.postalCode}`, ...client}));
        }, () => {
          return [];
        });
  }

  searchMdpId(value) {
    if (value.length < 3)
      return Promise.resolve([]);
    else
      return this.getMdpClients(value);
  }

  setClientFromMdp(client) {
    if (this.newClientProcess && !this.newClientMdpIdChanged) {
      delete this.newClientData.name.reliantOn;
      delete this.newClientData.taxId.reliantOn;
      this.newClientMdpIdChanged = true;
    }

    const valuesVariable = this.newClientProcess ? 'newClientValues': 'editClientValues';
    const dataVariable = this.newClientProcess ? 'newClientData' : 'editClientData';
    if (!client) {
      this[valuesVariable].mdpId = null;
      this[valuesVariable].mdpName = null;
    }
    else {
      this[valuesVariable].taxId = client.taxId && client.taxId.length > 0 ? client.taxId : 'MISSING';
      const newName = client.name && client.name.length > 0 ? client.name : '';
      if (!this[valuesVariable].name || this[valuesVariable].name.length === 0)
        this[valuesVariable].name = newName;
      else if (newName !== this[valuesVariable].name) {
        this[dataVariable].name.buttonHandlerDisabled = false;
        this.newNameFromMdp = newName;
      }
      this[valuesVariable].mdpId = client.id;
      this[valuesVariable].mdpName = client.name;
    }
  }

  onCountryChange(isEmployee) {
    if (isEmployee.key !== 'country')
      return;

    const countrySettings = this.countries.find(country => country.name === isEmployee.value);
    const mdpAvailable = countrySettings.flags.find(flag => flag === 'ClientMdpIdAvailable');
    const mdpRequired = countrySettings.flags.find(flag => flag === 'ClientMdpIdRequired');
    const dataVariable = this.newClientProcess ? 'newClientData' : 'editClientData';
    const valuesVariable = this.newClientProcess ? 'newClientValues': 'editClientValues';

    if (this.newClientProcess && !this.newClientValues.mdpId && mdpRequired) {
      this.newClientData.name.reliantOn = 'mdpId';
      this.newClientData.taxId.reliantOn = 'mdpId';
    } else {
      delete this.newClientData.name.reliantOn;
      delete this.newClientData.taxId.reliantOn;
    }

    if (mdpAvailable) {
      this[dataVariable].mdpInfo = {
        type: "textWithSearch",
        searchFn: (value) => this.searchMdpId(value),
        setClientFromMdp: (client) => this.setClientFromMdp(client),
        options: []
      };

      if (mdpRequired)
        this[dataVariable].mdpInfo.isNotRequired = false;

      this[dataVariable].name = {
        ...this[dataVariable].name,
        buttonHandlerDisabled: true,
        buttonHandlerLabel: 'Override',
        buttonHandler: () => this.overrideClientName()
      };

      this[valuesVariable].mdpId = null;
      this[valuesVariable].mdpName = null;
      this[dataVariable] = this.dataOrder.reduce((accu, curr) => {
        if (this.newClientProcess && curr === 'mdpId')
          return accu;

        accu[curr] = this[dataVariable][curr];
        return accu;
      }, {});
    } else {
      this[valuesVariable].mdpId = null;
      this[valuesVariable].mdpName = null;

      delete this[dataVariable].name.buttonHandlerDisabled;
      delete this[dataVariable].name.buttonHandlerLabel;
      delete this[dataVariable].name.buttonHandler;
      delete this[dataVariable].mdpInfo;
    }
  }

  downloadClientNotes(client) {
    this.Admin.getClientNotes(client.id)
      .then((success) => {
        this.DownloadFile.downloadFromResponse(
          success,
          'application/zip',
          `${client.name.replace(/\./g, '').toLowerCase()} process documentation`
        );
      }, (err) => {
        const message = String.fromCharCode.apply(null, new Uint8Array(err.data));

        this.Notes.postNote({
          type: "error",
          error: message.includes("Found zero notes for client")
            ? "Client has no notes."
            : "Something wrong happened. Try again later."
        });
      });
  }

  overrideClientName() {
    const valuesVariable = this.newClientProcess ? 'newClientValues': 'editClientValues';
    const dataVariable = this.newClientProcess ? 'newClientData' : 'editClientData';

    this[valuesVariable].name = this.newNameFromMdp;
    this.newNameFromMdp = null;
    this[dataVariable].name.buttonHandlerDisabled = true;
  }
}
